import { ENDPOINTS } from '../../apis/endpoints';
import { apiSlice } from '../../app/api/apiSlice';

export const announcementApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getFeedbacks: builder.query({
      query: () => `${ENDPOINTS.FEEDBACK.BASE}`,
      providesTags: (result) =>
        result
          ? [{ type: 'Feedback', id: 'LIST' }, ...result.map(({ _id }) => ({ type: 'Feedback', id: _id }))]
          : [{ type: 'Feedback', id: 'LIST' }],
    }),
    addFeedback: builder.mutation({
      query: (formData) => ({
        url: `${ENDPOINTS.FEEDBACK.SUBMIT}`,
        method: 'POST',
        body: formData,
      }),
      invalidatesTags: [{ type: 'Feedback', id: 'LIST' }],
    }),
    editFeedback: builder.mutation({
      query: ({ id, data }) => ({
        url: `${ENDPOINTS.FEEDBACK.BASE}${id}`,
        method: 'PUT',
        body: data,
      }),
      invalidatesTags: (result, error, { id }) => [{ type: 'Feedback', id }],
    }),
    deleteFeedback: builder.mutation({
      query: (id) => ({
        url: `${ENDPOINTS.FEEDBACK.BASE}${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: (result, error, id) => [{ type: 'Feedback', id }],
    }),
    deleteAllFeedbacks: builder.mutation({
      query: () => ({
        url: `${ENDPOINTS.FEEDBACK.DELETE_ALL}`,
        method: 'PUT',
      }),
      invalidatesTags: (result, error, id) => [{ type: 'Feedback', id }],
    }),
    getLinkPreview: builder.query({
      query: (url) => `${ENDPOINTS.UTILS.LINK_PREVIEW}?url=${encodeURIComponent(url)}`,
    }),
  }),
});

export const {
  useGetFeedbacksQuery,
  useAddFeedbackMutation,
  useEditFeedbackMutation,
  useDeleteFeedbackMutation,
  useDeleteAllFeedbacksMutation,
  useGetLinkPreviewQuery,
} = announcementApiSlice;
